import AddButton from "components/Button/AddButton";
import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import { ApiDeleteCashIn, ApiGetCashInList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import { GetStatus, money } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import XIcon from "assets/icon/XIcon";
import FilterIcon from "assets/icon/FilterIcon";
import DatePicker from "components/Input/DatePicker";
import moment from "moment";
import Dropdown from "components/Input/Dropdown";

export default function CashIn(){
    let navigate = useNavigate()

    const { data: cashInList, fetch: apiGetCashInList } = useFetch(ApiGetCashInList)
    const { fetch: apiDeleteCashIn } = useFetch(ApiDeleteCashIn)
    
    const [cashIn, setCashIn] = useState([])
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [isFilterOpen, setIsFilterOpen] = useState(false)

    const [cashInDate, setCashInDate] = useState(new Date())
    
    const isFilterOpenClick = () => {
        setIsFilterOpen(!isFilterOpen)
    }


    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        setLoading({isOpen: true})
        
        getCashInList().then((data) => {
            statusChange({value: status}, data)
            setLoading({isOpen: false})
        })

        
    },[cashInDate])

    // Function Api Call
    const getCashInList = async() => {
        let data = null

        await apiGetCashInList({
            data: {
                cashInDate: cashInDate
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setCashIn(response.data)
                data = response.data
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return data
    }
    const deleteCashIn = async(cashInId, status) => {
        await apiDeleteCashIn({
            data: {
                cashInId: cashInId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            setSuccessModal({  isOpen: false }) 
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Button Click Handlers
    const addBtnClick = () => {
        navigate("/cash-in/form?cashInId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (cashInId) => {
        navigate("/cash-in/form?cashInId=" + cashInId + "&formType=Edit")
    }
    const deleteBtnClick = (cashInId, status) => {
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading({isOpen: true})

                    deleteCashIn(cashInId, status).then(() => {
                        getCashInList().then((data) => {
                            statusChange({value: status}, data)
                            setLoading({isOpen: false})
                        })
                    })
                }
            }
        })
    }

    const statusChange = (e, data) => {
        setStatus(e.value)

        if (e.value === ""){
            setCashIn(cashInList.data)
            return
        }   

        if (cashInList !== null){
            if (cashInList.data.length === 0){
                setCashIn([])
                return
            } else {
                const filteredData = cashInList.data.filter((item) => item.status === e.value)
                setCashIn(filteredData) 
            }
        } 
        
        if (data !== null){
            if (data.length === 0){
                setCashIn([])
                return
            } else {
                const filteredData = data.filter((item) => item.status === e.value)
                setCashIn(filteredData) 
            }
        }
        
    }
    

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Cash In</span>
            </div>
            <hr />

            <div className="xl:hidden mt-5 flex justify-end">
                <button className="bg-black rounded-md flex gap-2 px-4 py-2" onClick={isFilterOpenClick}>
                    {isFilterOpen ? <XIcon className="fill-white w-6" /> : <FilterIcon className="fill-white w-6" />}
                    <span className="text-white">Filter</span>
                </button>
            </div>

            <div className={`flex flex-row gap-5 mt-5 ${isFilterOpen ? 'flex' : 'hidden xl:flex'}`}>
                <div className="flex flex-col gap-2 w-full sm:w-72">
                    <span>Cash In Date</span>
                        <div className="w-72">
                        <DatePicker className="w-full h-10 bg-white" value={cashInDate} onChange={(date) => setCashInDate(date)} />
                    </div>
                </div>
                <div className="flex flex-col gap-2 w-full sm:w-72">
                    <span>Status</span>
                        <div className="w-48">
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => statusChange(e, null)} placeholder="All" />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} />
            </div>
           
            <div className="hidden xl:block mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Cash In Date</th>
                            <th className="font-semibold text-left px-2">Amount</th>
                            <th className="font-semibold text-left px-2">Remark</th>
                            <th className="font-semibold text-left px-2">Status</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {cashIn?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ i+1 }</td>
                                    <td className="px-2">
                                        <span>{ moment(data.cashInDate).format("DD MMM YYYY") }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>Rp { money(data.amount) }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.remark }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button flex gap-2" onClick={() => editBtnClick(data.cashInId)}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.cashInId, data.status)}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.cashInId, data.status)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={2} className="font-semibold p-2 text-right">Total Amount:</td>
                            <td className="font-semibold p-2">
                                Rp { cashIn?.length > 0 ? money(cashIn?.reduce((sum, record) => sum + parseFloat(record.amount), 0)) : 0 }
                            </td>
                            <td colSpan={3} className="text-right font-semibold p-2">
                                Total Data: { cashIn?.length ?? 0 }
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            {/* <div className="block xl:hidden mt-5">
                <div className="flex flex-col gap-3">
                    {customerCardList?.data?.listData?.map((data, i) => {
                        return(
                            <div className="bg-white p-3 border shadow flex justify-between">
                                <div className="flex flex-col">
                                    <label>{data.customerName.toUpperCase()}</label>
                                    <label>{data.cardNumber}</label>
                                    <label>{data.bankName + " - " + data.cardVendorName}</label>
                                </div>
                                <div className="flex flex-col justify-between">
                                    <button className="button flex gap-2" onClick={() => editBtnClick(data.customerCardId)}>
                                        <EditIcon className="w-4 fill-white" />
                                    </button>
                                    <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.customerCardId, data.status)}>
                                        <TrashIcon className="w-4 fill-white" />
                                    </button>
                                    <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.customerCardId, data.status)}>
                                        <RevisionIcon className="w-4 fill-white" />
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div> */}

           

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}